import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cancel.svg'
import _imports_1 from '../assets/organisationColoured.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-dea63b4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col items-center w-full h-full paddingContainer overflow-y-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-auto mt-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-primary text-md text-center" }, "Welcome to CRYSTASURE !"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-black text-xs text-center mt-1" }, "To get the best experience, we recommend you to complete these onboarding steps")
], -1))
const _hoisted_3 = { class: "bg-white overflow-y-auto flex flex-col justify-between border mt-3 border-lightgrey rounded infoContainer w-full p-3" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "flex flex-col justify-center items-center h-full" }
const _hoisted_6 = { class: "text-primary text-sm font-semibold mb-1" }
const _hoisted_7 = { class: "text-xs text-black" }
const _hoisted_8 = { class: "w-3/4 mx-auto rounded-sm cursor-pointer" }
const _hoisted_9 = { class: "w-full flex items-center justify-between buttonContainer" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Organization", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "flex w-full mt-3" }
const _hoisted_18 = { class: "w-6/12 flex" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-t border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Legal Name ", -1))
const _hoisted_20 = { class: "border-b border-t border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_21 = { class: "w-6/12 flex" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b border-t p-2 header w-2/5 border-lightgrey flex items-center" }, "Org Key ", -1))
const _hoisted_23 = { class: "border border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_24 = { class: "flex w-full" }
const _hoisted_25 = { class: "w-6/12 flex" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "WebsiteUrl ", -1))
const _hoisted_27 = { class: "border-b border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_28 = { class: "w-6/12 flex" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Dispaly Name", -1))
const _hoisted_30 = { class: "border-l border-b border-r border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_31 = { class: "flex w-full" }
const _hoisted_32 = { class: "w-6/12 flex" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Region ", -1))
const _hoisted_34 = { class: "border-b border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_35 = { class: "w-6/12 flex" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Industry Sector ", -1))
const _hoisted_37 = { class: "border-l border-b border-r border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_38 = { class: "flex w-full" }
const _hoisted_39 = { class: "w-full flex" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-1/5 border-lightgrey flex items-center" }, "Logo", -1))
const _hoisted_41 = { class: "border-b border-r border-l border-lightgrey w-4/5 text-xs flex items-center p-2" }
const _hoisted_42 = { class: "flex w-full" }
const _hoisted_43 = { class: "w-full flex" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-1/5 border-lightgrey flex items-center" }, "Address-1", -1))
const _hoisted_45 = { class: "border-b border-r border-l border-lightgrey w-4/5 text-xs flex items-center p-2" }
const _hoisted_46 = { class: "flex w-full" }
const _hoisted_47 = { class: "w-full flex" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-1/5 border-lightgrey flex items-center" }, "Address-2", -1))
const _hoisted_49 = { class: "border-b border-r border-l border-lightgrey w-4/5 text-xs flex items-center p-2" }
const _hoisted_50 = { class: "flex w-full" }
const _hoisted_51 = { class: "w-6/12 flex" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "City ", -1))
const _hoisted_53 = { class: "border-b border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_54 = { class: "w-6/12 flex" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "State ", -1))
const _hoisted_56 = { class: "border-l border-b border-r border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_57 = { class: "flex w-full" }
const _hoisted_58 = { class: "w-6/12 flex" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Country ", -1))
const _hoisted_60 = { class: "border-b border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_61 = { class: "w-6/12 flex" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Pincode ", -1))
const _hoisted_63 = { class: "border-l border-b border-r border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_64 = { class: "flex w-full" }
const _hoisted_65 = { class: "w-6/12 flex" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Primary contact name", -1))
const _hoisted_67 = { class: "border-b border-l border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_68 = { class: "w-6/12 flex" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border-l border-b p-2 header w-2/5 border-lightgrey flex items-center" }, "Primary contact email", -1))
const _hoisted_70 = { class: "border-l border-b border-r border-lightgrey w-3/5 text-xs flex items-center p-2" }
const _hoisted_71 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Teams", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_74 = [
  _hoisted_73
]
const _hoisted_75 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_76 = {
  class: "formcontainer flex flex-wrap py-2",
  id: "formContainer"
}
const _hoisted_77 = { class: "text-xs" }
const _hoisted_78 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Systems", -1))
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_81 = [
  _hoisted_80
]
const _hoisted_82 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_83 = { class: "formcontainer flex flex-wrap gap-2 py-4" }
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 icon mr-2"
}
const _hoisted_86 = { class: "text-xs" }
const _hoisted_87 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Vendors", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_90 = [
  _hoisted_89
]
const _hoisted_91 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_92 = { class: "formcontainer flex flex-wrap gap-2 py-4" }
const _hoisted_93 = ["src"]
const _hoisted_94 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 icon mr-2"
}
const _hoisted_95 = { class: "text-xs" }
const _hoisted_96 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Frameworks", -1))
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_101 = { class: "formcontainer flex flex-wrap gap-2 py-4" }
const _hoisted_102 = ["src"]
const _hoisted_103 = {
  key: 1,
  src: _imports_1,
  class: "h-4 w-4 icon mr-2"
}
const _hoisted_104 = { class: "text-xs" }
const _hoisted_105 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Activities", -1))
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-5 w-5 cursor-pointer"
}, null, -1))
const _hoisted_108 = [
  _hoisted_107
]
const _hoisted_109 = { class: "statuscontainer popupbodycontainer scrollBarColour overflow-y-auto" }
const _hoisted_110 = { class: "formcontainer w-full py-2" }
const _hoisted_111 = { class: "tableShow w-full" }
const _hoisted_112 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup = _resolveComponent("popup")!
  const _component_newTable = _resolveComponent("newTable")!
  const _component_tool_tip = _resolveComponent("tool-tip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
          return (_openBlock(), _createElementBlock("div", {
            key: tab.id,
            onClick: ($event: any) => (_ctx.openSelectedPopup(tab.id)),
            class: "hover:shadow w-3/4 box min-[h-1/5] border border-lightgrey mb-2 mx-auto rounded-sm cursor-pointer"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(tab.name), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(tab.statement), 1)
            ])
          ], 8, _hoisted_4))
        }), 128)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goBackButton())),
              class: "btnprimary h-7 w-16 flex justify-center items-center taskEditButtons"
            }, "Back"),
            _createElementVNode("button", {
              disabled: _ctx.clickOnButton,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.finishOnBoard())),
              class: "btnprimary nextButton h-7 w-16 flex justify-center items-center"
            }, "Finish", 8, _hoisted_10)
          ])
        ])
      ])
    ]),
    (_ctx.orgPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.orgPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_14)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.storedOrgObject.organizationName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.storedOrgObject.organizationKey), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.storedOrgObject.websiteUrl), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.storedOrgObject.displayName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.storedOrgObject.region), 1)
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.storedOrgObject.industrySector), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.storedOrgObject.logoName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.storedOrgObject.addressLineOne), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _hoisted_48,
                        _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.storedOrgObject.addressLineTwo), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("div", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.storedOrgObject.city), 1)
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.storedOrgObject.state), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _hoisted_59,
                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.storedOrgObject.country), 1)
                      ]),
                      _createElementVNode("div", _hoisted_61, [
                        _hoisted_62,
                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.storedOrgObject.pinCode), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _hoisted_66,
                        _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.storedOrgObject.primaryContactName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_68, [
                        _hoisted_69,
                        _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.storedOrgObject.primaryContactEmail), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.teamPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.teamPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_74)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_75, [
                  _createElementVNode("div", _hoisted_76, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedTeamsList, (team) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: team.id,
                        class: "flex m-1 justify-center items-center teamWidth border border-lightgrey rounded"
                      }, [
                        _createElementVNode("div", _hoisted_77, _toDisplayString(team.displayName), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.systemsPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.systemsPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_78, [
              _hoisted_79,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_81)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_82, [
                  _createElementVNode("div", _hoisted_83, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedSystemsList, (team) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: team.id,
                        class: "flex items-center teamWidth h-10 border border-lightgrey rounded px-4"
                      }, [
                        (team.imageUrl != '')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: team.imageUrl,
                              class: "h-4 w-4 icon mr-2"
                            }, null, 8, _hoisted_84))
                          : (_openBlock(), _createElementBlock("img", _hoisted_85)),
                        _createElementVNode("div", _hoisted_86, _toDisplayString(team.systemName), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.vendorsPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 3,
          popUp: _ctx.vendorsPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_87, [
              _hoisted_88,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_90)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_91, [
                  _createElementVNode("div", _hoisted_92, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedVendorsList, (team) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: team.id,
                        class: "flex items-center teamWidth h-10 border border-lightgrey rounded px-4"
                      }, [
                        (team.imageUrl != '')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: team.imageUrl,
                              class: "h-4 w-4 icon mr-2"
                            }, null, 8, _hoisted_93))
                          : (_openBlock(), _createElementBlock("img", _hoisted_94)),
                        _createElementVNode("div", _hoisted_95, _toDisplayString(team.name), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.frameWorkPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.frameWorkPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_96, [
              _hoisted_97,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_99)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("div", _hoisted_101, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storedFrameWorks, (team) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: team.id,
                        class: "flex items-center teamWidth h-10 border border-lightgrey rounded px-4"
                      }, [
                        (team.imageSrc != '')
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: team.imageSrc,
                              class: "h-4 w-4 icon mr-2"
                            }, null, 8, _hoisted_102))
                          : (_openBlock(), _createElementBlock("img", _hoisted_103)),
                        _createElementVNode("div", _hoisted_104, _toDisplayString(team.frameWork), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.activitiesPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 5,
          popUp: _ctx.activitiesPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closePopup()))
              }, _hoisted_108)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _createVNode(_component_newTable, {
                        tableRowData: _ctx.storedActivities,
                        headersData: _ctx.headers,
                        openPopup: false,
                        navigate: false
                      }, null, 8, ["tableRowData", "headersData"]),
                      (_ctx.toolTipActive)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 64))
}